import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Translate from "../translate/Translate";
import { Button, Divider,Tag,Typography } from 'antd';
import RImage from '../static/resultDream-settings.png';
import IImage from '../static/resultDream-magnifier.png';
import AImage from '../static/resultDream-paint-palette.png';
import SImage from '../static/resultDream-conversation.png';
import EImage from '../static/resultDream-suitcase.png';
import CImage from '../static/resultDream-notes.png';
import field1 from '../static/resultDream-1.png';
import field2 from '../static/resultDream-2.png';
import field3 from '../static/resultDream-3.png';

import {
    RightOutlined, LeftOutlined
} from '@ant-design/icons';

import { resultDreamSearch, resultDreamDetailGet } from "../../modules/result";

class ResultDreamModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // visible: true,
            resultDreamSearchData: [],
            resultData: [],
            selectedDream: null,
            resultDreamDetail: {},
        }
    }

    componentDidMount() {
        // console.log("yo");
        // console.log(this.state.resultDreamSearchData)
        if (this.props.resultData) {
            this.setState({ resultData: this.props.resultData }, () => this.renderDreamSection())
        }

    }

    renderDreamSection() {
        //*********************TEST"廚師"********************** */
        for (const value of this.state.resultData.info.occupations) {
            // for (const value of data) {
            // (value) => {
            resultDreamSearch(value).then(
                (searchedData) => {
                    // console.log(this.state.resultDreamSearchData, value, searchedData);
                    let data = {}
                    if (Object.keys(data).length === 0) {
                        data.name = value
                        data.result = searchedData
                    }
                    else {
                        data.name = value
                        data.result.total = searchedData.total
                        data.result.results = searchedData.results
                    }

                    this.setState({ resultDreamSearchData: this.state.resultDreamSearchData.concat(data) });
                    let test = "test"
                    if (searchedData.total > 0) {
                        for (const value of searchedData.results) {
                            // (value) => {
                            resultDreamDetailGet(value["_id"]).then(
                                (detail) => {
                                    this.setState({
                                        resultDreamDetail: {
                                            ...this.state.resultDreamDetail,
                                            [value["_id"]]: detail
                                        }
                                    });
                                }
                            )
                            // console.log(this.state.resultDreamDetail)
                            // }
                        }

                    }

                }
            ).catch(
                (error) => {
                    // console.log(error);
                }
            )
        }

    }

    // componentDidUpdate(prevProps, prevState) {
    //     Object.entries(this.props).forEach(([key, val]) =>
    //         prevProps[key] !== val && console.log(`Prop '${key}' changed${val}`)
    //     );
    //     if (this.state) {
    //         Object.entries(this.state).forEach(([key, val]) => {
    //             prevState[key] !== val && console.log(`State '${key}' changed${val}`)
    //             // if(key=="selectedDream"){
    //             //     this.props.resultDreamDetailGet(val)
    //             // }
    //         }

    //         );
    //     }
    // }

    checkDream(target) {
        this.setState({ selectedDream: target })
    }

    

    render() {
        const image = { R: RImage, I: IImage, A: AImage, S: SImage, E: EImage, C: CImage };
        const { resultDreamDetail, selectedDream, resultData, resultDreamSearchData } = this.state;
        const hashtagcolour=["magenta", "red", "volcano" , "orange", "gold"]

        return (
            <div >
                {
                    (!selectedDream) ?
                        (resultData) ?
                            (resultDreamSearchData.length > 0 && resultDreamSearchData.length == resultData.info.occupations.length) ?
                                resultDreamSearchData.map(
                                    (value, key) => {
                                        // console.log(this.state.resultDreamSearchData)
                                        return (
                                            <div key={key} className="resultDreamSearchRedirectFieldContainer">
                                                <h3 className="resultDreamSearchRedirectFieldHeader"><Translate id="resultDream.description.title1" />{value.name}<Translate id="resultDream.description.title2" /></h3>
                                                {
                                                    (value.result.total > 0) ?
                                                        value.result.results.map(
                                                            (dreamData) => {
                                                                // console.log(dreamData)
                                                                return (
                                                                    <Button
                                                                        key = {dreamData["_id"]}
                                                                        onClick={this.checkDream.bind(this, dreamData["_id"])}
                                                                        type="primary" className={"resultDreamBtn  resultDreamBtnColor"} >
                                                                        {dreamData.name.map(
                                                                            value => {
                                                                                // console.log(value)
                                                                                if (value.lang == this.props.language)
                                                                                    return (
                                                                                        value.name
                                                                                    )
                                                                            }
                                                                        )
                                                                        }
                                                                        <RightOutlined className="resultBtnMore" />
                                                                    </Button>
                                                                )
                                                            }
                                                        )
                                                        : <Translate id="resultDream.notfound" />


                                                }
                                                <p></p>
                                            </div>
                                        )
                                    }
                                )
                                : <Translate id="resultDream.notfound" />
                            : <Translate id="resultDream.notfound" />
                        :
                        // -------------------------------Detail--------------------------------
                        <div>
                            <Button type="link" onClick={() => this.setState({ selectedDream: null })}><LeftOutlined /></Button>
                            <div className="resultDreamDetailContainer">
                                <div className="resultDreamDetailField resultDreamDetailTitle">
                                    <span><Typography.Title level={5}>{resultDreamDetail[selectedDream]["name"][0]["name"]}</Typography.Title></span>
                                    <span className={"resultDreamColor"+resultDreamDetail[selectedDream]["code"][0]}><img src={image[resultDreamDetail[selectedDream]["code"][0]]} className="resultDreamImg"></img><Translate id={"type." + resultDreamDetail[selectedDream]["code"][0]}></Translate></span>
                                </div>
                                <div className="resultDreamDetailField popuptextColor">
                                    <span><Translate id="resultDream.Intro"></Translate>:
                                    {resultDreamDetail[selectedDream]["career"].map(
                                        (value) => {
                                            // console.log(value)
                                            if (value.lang == this.props.language)
                                                return (value.description)} )
                                        }
                                    </span>
                                    <span className="resultDreamDetailTitle"><Translate id="resultDream.SDS"></Translate>:&nbsp;{resultDreamDetail[selectedDream]["code"]}</span>
                                </div>

                                <div className="resultDreamDetailDescriptionField">
                                    <div className="resultDreamDetailDescription">
                                    <div ><img src={field1} className="resultDreamTitleImg"></img><Translate id="resultDream.detail.title1"></Translate></div>
                                        {
                                            resultDreamDetail[selectedDream]["description"].map(
                                                (value) => {
                                                    // console.log(value)
                                                    if (value.lang == this.props.language){
                                                        return value.descriptions.map(
                                                            (descrip,index)=>{return(<div key={index} className="popuptextColor resultDreamDetail">{index+1}. {descrip}</div>)}
                                                        )
                                                    }
                                                }
                                            )
                                        }
                                    </div>
                                    <Divider type="vertical"/>
                                    <div className="resultDreamDetailDescription">
                                        <div ><img src={field2} className="resultDreamTitleImg"></img><Translate id="resultDream.detail.title2"></Translate></div>
                                        {
                                            resultDreamDetail[selectedDream]["character"].map(
                                                (value) => {
                                                    // console.log(value)
                                                    if (value.lang == this.props.language){
                                                        return value.characters.map(
                                                            (descrip,index)=>{return(<div key={index} className="popuptextColor resultDreamDetail">{index+1}. {descrip}</div>)}
                                                        )
                                                    }
                                                }
                                            )
                                        }
                                    </div>
                                    <Divider type="vertical"/>
                                    <div className="resultDreamDetailDescription">
                                        <div ><img src={field3} className="resultDreamTitleImg"></img><Translate id="resultDream.detail.title3"></Translate></div>
                                        {
                                            resultDreamDetail[selectedDream]["requirement"].map(
                                                (value) => {
                                                    // console.log(value)
                                                    if (value.lang == this.props.language){
                                                        return value.requirements.map(
                                                            (descrip,index)=>{return(<div key={index} className="popuptextColor resultDreamDetail">{index+1}. {descrip}</div>)}
                                                        )
                                                    }
                                                }
                                            )
                                        }
                                    </div>
                                </div>

                                <div style={{padding: "5px 0"}}>
                                    <Translate id="resultDream.detail.title4"></Translate>:&nbsp;
                                    {
                                            resultDreamDetail[selectedDream]["hashTag"].map(
                                                (value) => {
                                                    // console.log(value)
                                                    if (value.lang == this.props.language){
                                                        return value.hashTags.map(
                                                            (hashTag,index)=>{return(<Tag key={index} color={hashtagcolour[index]}># {hashTag}</Tag>)}
                                                        )
                                                    }
                                                }
                                            )
                                        }
                                </div>
                            </div>
                        </div>
                }
            </div>
        )
    }
}

const mapStateToProps = state => ({
    language: state.mainpage.language,
    resultData: state.result.resultData,
    // resultDreamSearchData: state.result.resultDreamSearchData,
    // resultDreamDetail: state.result.resultDreamDetail,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            // resultDreamSearch, resultDreamDetailGet
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ResultDreamModal);
